const i18n = require(`./apps/${process.env.APP_ID}/src/i18n.js`)

export default i18n.default
